import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "src/components/Modals/ConfirmationModals/ConfirmationModal";
import { useUpdateLesson } from "src/hooks/useCourses";

interface DeleteLessonNoteConfirmationModalProps {
	onClose: () => void;
	lessonId: string;
	courseId: string;
	onSuccess: () => void;
}

export const DeleteLessonNoteConfirmationModal = ({
	onClose,
	lessonId,
	courseId,
	onSuccess,
}: DeleteLessonNoteConfirmationModalProps) => {
	const { t } = useTranslation();
	const { mutateAsync: setNote, isPending: isLoading } =
		useUpdateLesson() as unknown as {
			mutateAsync: (payload: {
				lessonId: string;
				courseId: string;
				data: { note: null };
			}) => Promise<void>;
			isPending: boolean;
		};

	const onConfirm = async () => {
		await setNote({
			lessonId,
			courseId,
			data: {
				note: null,
			},
		});
		onSuccess();
	};

	return (
		<ConfirmationModal
			title={t("modals.confirm.deleteLessonNote.title")}
			onConfirm={onConfirm}
			onClose={onClose}
			isLoading={isLoading}
		>
			<p className="m-0 text-center">
				{t("modals.confirm.deleteLessonNote.subtitle")}
			</p>
		</ConfirmationModal>
	);
};
